import React, { type ReactNode } from 'react'

function CheckQuizIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.94569 14.5339C10.7817 14.5339 13.8914 11.4243 13.8914 7.58826C13.8914 3.75227 10.7817 0.642578 6.94569 0.642578C3.10969 0.642578 0 3.75227 0 7.58826C0 11.4243 3.10969 14.5339 6.94569 14.5339Z"
        fill="var(--color-green)"
      />
      <path
        d="M9.95478 5.61133L5.83468 9.73143L3.96191 7.85866"
        stroke="var(--color-background-primary)"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckQuizIcon
